import UpdateCaseModal from "./UpdateCaseModal";

export default UpdateCaseModal;
